import * as React from 'react';
import { Suggestion, SuggestionKind } from 'owa-search-service/lib/data/schema/SuggestionSet';
import QuickAddCalendarButton from '../components/QuickAddCalendarButton';
import isBusiness from 'owa-session-store/lib/utils/isBusiness';

export default function getQuickActionsForSuggestion(suggestion: Suggestion): JSX.Element[] {
    if (suggestion.kind == SuggestionKind.People && isBusiness()) {
        return [
            <QuickAddCalendarButton
                key="quickadd"
                displayName={suggestion.DisplayName}
                emailAddress={suggestion.EmailAddresses[0]}
                mailboxType={suggestion.MailboxType}
            />,
        ];
    }
    return [];
}
